import { useCallback, useEffect, useState } from "react";
import { http, formatApiError } from "../../lib/api";
import { toast } from "../../lib/notify";

export const currentMonth = () => new Date().toISOString().slice(0, 7);

// ATM listesi (proje + ay): planlanan / gerçekleşen / eksik silim sayıları backend'den gelir; enabled=false → istek atılmaz (önce proje seçimi)
export function useAtms(projectId, month, enabled = true) {
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);
  const load = useCallback(async () => {
    if (!enabled) { setRows([]); setLoading(false); return; }
    setLoading(true);
    try {
      const { data } = await http.get("/atms", { params: { project_id: projectId || undefined, month } });
      setRows(data);
    } catch (e) { toast.error(formatApiError(e)); } finally { setLoading(false); }
  }, [projectId, month, enabled]);
  useEffect(() => { load(); }, [load]);
  return { rows, load, loading };
}

export const sumBy = (rows, k) => rows.reduce((s, r) => s + (Number(r[k]) || 0), 0);

// md (768px) ve üstü: masaüstü tablo; altı: mobil kartlar — ikisi aynı anda render edilmez (silim listesi tek kez çekilir)
export function useIsDesktop() {
  const [desktop, setDesktop] = useState(() => window.matchMedia("(min-width: 768px)").matches);
  useEffect(() => {
    const mq = window.matchMedia("(min-width: 768px)");
    const on = (e) => setDesktop(e.matches);
    mq.addEventListener("change", on);
    return () => mq.removeEventListener("change", on);
  }, []);
  return desktop;
}
